import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useMutation, useQueryCache } from 'react-query'
import { postProduct } from '../../../../Api/index'
import ExpandedRecordsProduct from '../../ExpandedRecords/ExpandedRecordsProduct'
import useStore from '../../ProductStore/Store'
import expandedRecordIcon from '../../images/expandedSVG.svg'

function Results () {
  const { dataResults, isQueryLoading } = useStore()
  const dataRecords = dataResults?.data?.records

  // State to manage modal visibility and record data
  const [isModalOpen, setModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [isLoadingRecord, setLoadingRecord] = useState(false)
  const [errorNotEnoughCredits, setErrorNotEnoughCredits] = useState(false)
  const [snackBarStateError, setSnackBarStateError] = useState(false)

  const queryCache = useQueryCache()

  // Mutation to fetch record details if not in cache
  const [mutate] = useMutation(postProduct, {
    onSuccess: data => {
      const newRecord = data?.data?.records[0]
      if (newRecord) {
        const cacheKey = `recordByID-${newRecord.keys[0]}`
        queryCache.setQueryData(cacheKey, newRecord)
        setSelectedRecord(newRecord)
        setModalOpen(true)
        setLoadingRecord(false)
      }
    },
    // onError: () => {
    //   setLoadingRecord(false)
    // }

    onError: () => {
      setSnackBarStateError(true)
      setTimeout(() => {
        setErrorNotEnoughCredits(true)
        setLoadingRecord(false)
      }, 1000)
    }
  })

  // Handle clicking on a record: check cache or fetch new data
  const handleRecordClick = record => {
    const cacheKey = `recordByID-${record.keys[0]}`
    const cachedData = queryCache.getQueryData(cacheKey)

    setModalOpen(true)
    setSelectedRecord(cachedData || null)
    setLoadingRecord(!cachedData)

    if (!cachedData && !isQueryLoading) {
      mutate({ query: `keys:"${record?.keys[0]}"` })
    } else if (cachedData) {
      setLoadingRecord(false)
    }
  }

  // Clean up any cached queries starting with "recordByID"
  useEffect(() => {
    if (queryCache) {
      queryCache.getQueries().forEach(query => {
        if (
          typeof query?.queryKey[0] === 'string' &&
          query.queryKey[0].startsWith('recordByID')
        ) {
          queryCache.removeQueries(query.queryKey)
        }
      })
    }
  }, [dataResults, queryCache])

  return (
    <section className={styles.searchResultsContainerWithScroll}>
      {dataRecords?.map((record, index) => (
        <div
          onClick={() => handleRecordClick(record)}
          key={index}
          className={styles.searchResultsContainer}
          style={{
            opacity: isQueryLoading ? 0.5 : 1,
            cursor: isQueryLoading ? 'not-allowed' : 'pointer'
          }}
        >
          <div className={styles.expandedRecordPeopleContainer}>
            <div className={styles.expandedRecordPeopleName}>
              <span className={styles.expandedRecordPeopleNameText}>
                {record.name ? record.name : 'N/A'}
              </span>
            </div>
            <div>
              <img
                className={styles.expandedRecordPeopleIcon}
                src={expandedRecordIcon}
                alt='ExpandIcon'
              />
            </div>
          </div>

          <div className={styles.expandedRecordPeopleDetails}>
            <div className={styles.listingItem} style={{ width: '125px' }}>
              <span className={styles.expandedRecordPeopleDetail}>Brand</span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.brand ? record.brand : 'N/A'}
              </span>
            </div>

            <div className={styles.listingItem} style={{ width: '100px' }}>
              <span className={styles.expandedRecordPeopleDetail}>
                Model no
              </span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.manufacturerNumber ? record.manufacturerNumber : 'N/A'}
              </span>
            </div>

            <div className={styles.listingItem} style={{ width: '125px' }}>
              <span className={styles.expandedRecordPeopleDetail}>
                Most recent price
              </span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.mostRecentPriceAmount
                  ? `$${record.mostRecentPriceAmount.toLocaleString('en-US')}`
                  : 'N/A'}
              </span>
            </div>

            <div className={styles.listingItem} style={{ width: '175px' }}>
              <span className={styles.expandedRecordPeopleDetail}>
                Categories
              </span>
              <span className={styles.expandedRecordPeopleValue}>
                {Array.isArray(record.categories) &&
                record.categories.length > 0
                  ? record.categories.slice(0, 3).join(', ')
                  : 'N/A'}
              </span>
            </div>

            <div className={styles.listingItem} style={{ width: '200px' }}>
              <span className={styles.expandedRecordPeopleDetail}>
                Taxonomy
              </span>
              <span className={styles.expandedRecordPeopleValue}>
                {Array.isArray(record.taxonomy) && record.taxonomy.length > 0
                  ? record.taxonomy[0].replace(/>/g, ' / ')
                  : 'N/A'}
              </span>
            </div>

            <div className={styles.listingItem} style={{ width: '125px' }}>
              <span className={styles.expandedRecordPeopleDetail}>
                UPC/GTIN
              </span>
              <span className={styles.expandedRecordPeopleValue}>
                {Array.isArray(record.gtins) && record.gtins.length > 0
                  ? record.gtins[0].replace(/>/g, ' / ')
                  : 'N/A'}
              </span>
            </div>

            <div className={styles.listingItem} style={{ width: '175px' }}>
              <span className={styles.expandedRecordPeopleDetail}>SKUs</span>
              <span className={styles.expandedRecordPeopleValue}>
                {Array.isArray(record.skus) && record.skus.length > 0 ? (
                  <>
                    {record.skus[0].value}
                    {record.skus.length > 1 && (
                      <span className={styles.moreSkus}>
                        {' '}
                        (+{record.skus.length - 1} more)
                      </span>
                    )}
                  </>
                ) : (
                  'N/A'
                )}
              </span>
            </div>
          </div>
        </div>
      ))}

      {isModalOpen && (
        <ExpandedRecordsProduct
          recordData={selectedRecord}
          isLoadingRecord={isLoadingRecord}
          errorNotEnoughCredits={errorNotEnoughCredits}
          setErrorNotEnoughCredits={setErrorNotEnoughCredits}
          snackBarStateError={snackBarStateError}
          onClose={() => setModalOpen(false)}
        />
      )}
    </section>
  )
}

export default Results
